module.exports = __webpack_public_path__ + "-1.svg?a8e0cf8c00d80f36cf6873de274f6452";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactions/-1.svg
// module id = 95
// module chunks = 0